import { LocalePrefixToURLPathsMap } from '@tmh-website/shared/cms';
import { LocalePrefix } from '@tmh-website/shared/const';
import { Place } from 'schema-dts';
import slugify from 'slugify';

export interface JobDescriptionImage {
  url: string;
  alt: string;
}

export interface JobContactPerson {
  name: string;
  phone: string;
  img?: JobDescriptionImage;
}

export interface JobDescription {
  headline: string;
  text: string;
  image?: JobDescriptionImage;
}

export interface Job {
  /**
   * Internal property to properly distigunish between different different job types.
   */
  _source: JobSource;
  id: string;
  createdAt: string;
  title: string;
  location: string;
  team: string;
  employmentType: string;
  url: string;
  descriptions?: JobDescription[] | null;
  contactPerson?: JobContactPerson | null;
  fitDescription?: { headline: string; text: string };
  seniority?: string;
  experience?: string;
  schedule?: string;
}

export enum JobSource {
  Personio = 'personio',
  Workable = 'workable',
}

export type JobCompact = Pick<Job, '_source' | 'id' | 'title' | 'location' | 'team' | 'employmentType' | 'url'>;

// TODO: Move this to Strapi to keep it up to date and add more entries
// addressCountry is required so we can't use the Personio data alone
export const locations: Record<string, Place> = {
  München: {
    '@type': 'Place',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'St.-Cajetan-Str. 43',
      addressLocality: 'München',
      addressRegion: 'Bayern',
      postalCode: '81669',
      addressCountry: 'DE',
    },
  },
};

export const localesWithPersonio = [LocalePrefix.De, LocalePrefix.DeCH, LocalePrefix.En];

export function getJobPath(job: Job | JobCompact, locale: LocalePrefix): string {
  switch (job._source) {
    case JobSource.Personio: {
      return `/${locale}/${LocalePrefixToURLPathsMap[locale].ourCompany}/${LocalePrefixToURLPathsMap[locale].career}/${
        job.id
      }/${slugify(job.title, {
        lower: true,
        strict: true,
      })}`;
    }
    case JobSource.Workable: {
      return job.url;
    }
    default: {
      throw new Error(`Job has invalid source: ${job._source}`);
    }
  }
}
